import React from 'react'
import { Grid } from '@material-ui/core'
import useDjangoForm from 'app/hooks/useDjangoForm'
import { FormContextProvider } from 'app/contexts/FormContext'
import FormField from 'app/reusable/form/FormField'
import { Loading } from '../SimpleList/SimpleList'

/**
 * The backend-generated form of a record (`useDjangoForm`), every visible
 * field in a two-column grid, for the global modal (`useModal`). Creates a
 * record without an `id`, edits it with one. `onSuccess` runs after a
 * successful save; lists of the model reload on their own through the
 * model-change event `useDjangoForm` fires.
 */
const RecordFormModal = ({ djangoApp, djangoModel, id, onSuccess }) => {
  const formContext = useDjangoForm({ djangoApp, djangoModel, id })
  const { fields, ordered_fields, loading } = formContext

  return (
    <FormContextProvider value={formContext}>
      {loading ? (
        <Loading />
      ) : (
        <Grid container spacing={3} className="mb-4">
          {ordered_fields
            ?.filter((name) => !fields[name]?.widget.is_hidden)
            .map((name) => (
              <Grid item xs={12} sm={6} key={name}>
                <FormField name={name} />
              </Grid>
            ))}
        </Grid>
      )}
      <FormField name="submit_button" onSuccess={onSuccess} />
    </FormContextProvider>
  )
}

export default RecordFormModal
